import React from "react"
import Skeleton from "../../components/Common/Skeleton"

const SKELETON_COUNT = 3

/**
 * Shimmer placeholder matching the My / Public Profile project card.
 */
export const ProfileProjectSkeleton = ({ showActions = true }) => (
  <article
    className="my-profile__project-card my-profile__project-card--skeleton"
    aria-hidden="true"
  >
    <Skeleton width={42} height={42} />
    <div className="my-profile__project-skeleton-info">
      <Skeleton width="46%" height={16} />
      <Skeleton width="72%" height={12} />
    </div>
    <div className="my-profile__project-skeleton-avatars">
      <Skeleton width={28} height={28} circle />
      <Skeleton width={28} height={28} circle />
      <Skeleton width={28} height={28} circle />
    </div>
    {showActions ? (
      <>
        <Skeleton width={88} height={28} />
        <Skeleton width={112} height={32} />
      </>
    ) : null}
  </article>
)

export const ProfileProjectSkeletonList = ({
  count = SKELETON_COUNT,
  showActions = true,
}) =>
  Array.from({ length: count }).map((_, index) => (
    <ProfileProjectSkeleton key={`project-skel-${index}`} showActions={showActions} />
  ))

export const OngoingRoleSkeletonList = ({ count = 2 }) =>
  Array.from({ length: count }).map((_, index) => (
    <article
      key={`ongoing-skel-${index}`}
      className="my-profile__ongoing-card my-profile__project-card--skeleton"
      aria-hidden="true"
    >
      <Skeleton width={42} height={42} />
      <div className="my-profile__project-skeleton-info">
        <Skeleton width="42%" height={16} />
        <Skeleton width="68%" height={12} />
      </div>
    </article>
  ))
